import * as angular from "angular";
import template from "./layout.html";

export default angular.module("vesl.extensions.json-schema.layout", [])
	.component("jsonSchemaLayout", {
		template,
		bindings: {
			session: "<",
			ui: "<",
			context: "<",
			basePath: "<",
			enabled: "<",
			revision: "<"
		}
	})
	.name;
